import { EmployeeActions, ErrorActions } from 'common/constants/actions';

const initialState = {
  employee_permission: [],
  employee_org_permission: [],
  pending: false,
  created: false,
  updated: false,
};

export default function EmployeePermission(state = initialState, action) {
  switch (action.type) {
    case EmployeeActions.PERMISSIONS.GET_PENDING:
      return {
        ...state,
        pending: true,
      };

    case EmployeeActions.PERMISSIONS.GET:
      return {
        ...state,
        employee_permission: action.payload,
        pending: false,
        created: false,
      };

    case EmployeeActions.PERMISSIONS.GET_ORG:
      return {
        ...state,
        employee_org_permission: action.payload,
        pending: false,
        created: false,
      };

    case EmployeeActions.PERMISSIONS.FETCH:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
        created: false,
      };

    case EmployeeActions.PERMISSIONS.EDIT:
      if (state.employee_permission.filter(an => an.id === action.payload.id)[0]) {
        state = {
          ...state,
          employee_permission: state.employee_permission.filter(rw => rw.id !== action.payload.id),
        };
      }
      return {
        ...state,
        created: false,
        employee_permission: [...state.employee_permission, action.payload],
      };

    case EmployeeActions.PERMISSIONS.DELETE:
      return {
        ...state,
        employee_permission: state.employee_permission.filter(row => row.id !== action.payload.id),
      };

    case EmployeeActions.PERMISSIONS.ADD:
      return {
        ...state,
        created: action.payload,
        employee_permission: [...state.employee_permission, action.payload],
      };

    case EmployeeActions.PERMISSIONS.CLEAR:
      return {
        ...state,
        employee_permission: [],
        employee_org_permission: [],
        created: false,
        updated: false,
        pending: false,
      };

    case ErrorActions.CLEAR_ALL:
      return {
        ...state,
        employee_permission: [],
        employee_org_permission: [],
        created: false,
        updated: false,
        pending: false,
      };

    default:
      return state;
  }
}
